import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';

@Component({
  selector: 'app-open-outreach',
  templateUrl: './open-outreach.component.html',
  styleUrl: './open-outreach.component.scss',
})
export class OpenOutreachComponent implements OnInit {
  doctor_id: any;
  constructor(
    private _apiService: ApiService,
  ) {}

  ngOnInit(): void {
    this.update_outreach_status({});
  }

  update_outreach_status(data?: any) {
      this._apiService.api(data, 'sync_ses_verification_statuses', 'post').subscribe((res: any) => {
          if (res.is_error == 0) {
            console.log('Outreach status updated successfully');
          } else {
            console.error('Failed to update outreach status');
          }
        });
  }
}
